export default "__VITE_ASSET__pwLd1JXO__"